import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const ViewUserSideBar = () => {
    const location = useLocation();
    let page = location.pathname.split('/view/user/').pop();
    const id = location.pathname.split('/').pop();
    const [activeSection, setActiveSection] = useState(page ? page : `profile/${id}`);
    return (
        <>
            <div className="dashboard">
                <div className="side-nav">
                    <ul className="ul">
                        <li className={activeSection === `profile/${id}` && 'activeli'}><NavLink to={`/view/user/profile/${id}`} onClick={() => setActiveSection(`profile/${id}`)}>Profile</NavLink></li>
                        <li className={activeSection === `posts/${id}` && 'activeli'}><NavLink to={`/view/user/posts/${id}`} onClick={() => setActiveSection(`posts/${id}`)}>Posts</NavLink></li>
                        <li className={activeSection === `donations/${id}` && 'activeli'}><NavLink to={`/view/user/donations/${id}`} onClick={() => setActiveSection(`donations/${id}`)}>Donations</NavLink></li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default ViewUserSideBar;
